import AcademicService from "@/service/AcademicService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Academic } from "@/model/Academic";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import academicValidationObj from "./S080300-AcademicValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var academicDataValidationObj = new academicValidationObj();
export default {
  name: "academic",
  mounted() {
    academicDataValidationObj.academicValidation();
    this.assignRights();
    this.resetAcademicData();
    this.init();
    this.getAllAcademics();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_Academic,
    Settings: Settings,
    dictEnum: dictEnum,
    academic: new Academic(),
    isEditMode: false,
    academicList: [],
    selectAllAcademic: false,
    tempAcademicModel: new Academic(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".academic-table table thead").height();
      var pagginationHeight = $(".paggination-academic").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllAcademics() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await AcademicService.getAllAcademicsByPagination(obj);
      if (response.data.IsSuccess) {
        self.academicList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAcademicDetail() {
      var self = this;
      const obj = {
        academicCode: self.tempAcademicModel.AcademicCode,
      };
      const response = await AcademicService.getAcademicsDetail(obj);
      if (response.data.IsSuccess) {
        self.academic = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllAcademicRecord: function () {
      var self = this;
      var IsSelected = self.selectAllAcademic;
      self.academicList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleAcademicPopup: function () {
      var arrayList = [];
      var self = this;
      self.academicList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteAcademicModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleAcademic() {
      var arrayList = [];
      var self = this;
      $('#deleteAcademicModel').modal('hide');
      self.academicList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        academicList: arrayList,
      };
      const response = await AcademicService.deleteAcademics(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetAcademicData();
        self.init();
        await self.getAllAcademics();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnAcademicSelect: function (model) {
      this.tempAcademicModel = model;
    },
    addAcademic: function () {
      var self = this;
      $('#academicModel').modal('show');
      self.isEditMode = false;
      self.academic = new Academic();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveAcademicData(obj) {
      var self = this;
      const response = await AcademicService.addAcademics(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetAcademicData();
        self.init();
        await self.getAllAcademics();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditAcademicData(obj) {
      var self = this;
      const response = await AcademicService.updateAcademics(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetAcademicData();
        self.init();
        await self.getAllAcademics();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveAcademic() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#academicModel').modal('hide');
          const obj = {
            model: {
              AcademicCode: self.academic.AcademicCode,
              CDesc: self.academic.CDesc,
              EDesc: self.academic.EDesc
            }
          };
          if (self.isEditMode) {
            self.EditAcademicData(obj);
          }
          else {
            self.saveAcademicData(obj);
          }
        }
      });
    },
    async editAcademic() {
      var self = this;
      self.isEditMode = true;
      if (self.tempAcademicModel.AcademicCode != "") {
        await self.getAcademicDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#academicModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetAcademicData: function () {
      var self = this;
      self.selectAllAcademic = false;
      self.isEditMode = false;
      self.academic = new Academic();
      self.tempAcademicModel = new Academic();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeAcademicPopup: function () {
      var self = this;
      self.selectAllAcademic = false;
      self.isEditMode = false;
      self.academic = new Academic();
      self.tempAcademicModel = new Academic();
      self.$validator.reset();
      self.vErrors.clear();
      $('#academicModel').modal('hide');
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllAcademics();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080300-Academic/S080300-Academic.js